import React, {Fragment} from "react";
import StepOptionSelection from "components/Step/StepOptionSelection";
import StepButton from "components/Step/StepButton";
import StepQuestion from "components/Step/StepQuestion";
import {RegistrationElements} from "domain/Registerv2/RegistrationElements";
import GenderEnum from "domain/Registerv2/GenderEnum";
import IdTypeEnum from "domain/Customer/IdTypeEnum";

const GENDER_LIST = [
    {value: GenderEnum.MALE, text: "Male", icon: "fa-mars"},
    {value: GenderEnum.FEMALE, text: "Female", icon: "fa-venus"},
]

export default class GenderCaptureStep extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedIndex: this.getSelectedIndex(this.props.value)
        }
    }

    getSelectedIndex(value) {
        for (let i = 0; i < GENDER_LIST.length; i++) {
            if (GENDER_LIST[i].value === value) {
                return i;
            }
        }
        return -1;
    }

    setSelectedIndex(index) {
        this.setState({
            selectedIndex: index
        });
    }

    onNextClick() {
        if (this.props.onNextClick) {
            let selectedItem = GENDER_LIST[this.state.selectedIndex];
            this.props.onNextClick(selectedItem.value);
        }
    }

    render() {
        return <Fragment>
            {
                this.props[RegistrationElements.ID_TYPE] === IdTypeEnum.SA_ID
                    ? this.renderGenderPredefined()
                    : this.renderGenderSelection()
            }
            <StepButton
                onClick={this.onNextClick.bind(this)}
                disabled={this.state.selectedIndex === -1}
            >
                {this.props.nextText || "Next"}
            </StepButton>
            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                {this.props.backText || "Back"}
            </StepButton>
        </Fragment>
    }

    renderGenderSelection() {
        return <Fragment>
            <StepQuestion>
                Please confirm your gender:
            </StepQuestion>
            <div className={"step_selection_list"}>
                {
                    GENDER_LIST.map((singleGender, index) => {
                        return this.renderSingle(singleGender.value, singleGender.text, singleGender.icon, index)
                    })
                }
            </div>
        </Fragment>
    }

    renderGenderPredefined() {
        return <Fragment>
            <StepQuestion>
                Based on your ID Number, your gender has been determined as:
            </StepQuestion>
            <div className={"step_selection_list"}>
                {
                    GENDER_LIST.map((singleGender, index) => {
                        if (singleGender.value === this.props.value)
                            return this.renderSingle(singleGender.value, singleGender.text, singleGender.icon, index);
                        return <Fragment key={index}/>
                    })
                }
            </div>
        </Fragment>
    }

    renderSingle(value, text, icon, index) {
        let isCurrentlySelected = this.state.selectedIndex === index;
        return <Fragment key={index}>
            <StepOptionSelection
                key={index}
                className={isCurrentlySelected ? "active" : ""}
                onClick={() => {
                    if (!this.props.readOnly) {
                        this.setSelectedIndex(index);
                    }
                }}
            >
                <div className="step_selection_item">
                    <div className="step_selection_item_icon">
                        <span className={"fa " + icon}/>
                    </div>
                    <div className="step_selection_item_text">
                        <span>{text}</span>
                    </div>
                    <div className="step_selection_item_check">
                        {isCurrentlySelected && <i className={"fa fa-check"}/>}
                    </div>
                </div>
            </StepOptionSelection>
        </Fragment>
    }
}
